<template>
    <router-link :to="`/comments/${comment.id}`">
        <div
            class="px-6 py-2 border border-gray-100 rounded shadow-sm hover:shadow transition duration-150"
        >
            <div class=" flex items-center justify-between space-x-2">
                <h3 class="flex-1">{{ comment.message }}</h3>
                <span
                    v-if="comment.isDeleted"
                    class="flex items-center justify-center text-xs text-red-700"
                >
                    <svg
                        class="h-4 w-4 text-red-700 mr-1"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                        ></path>
                    </svg>
                    Deleted</span
                >
            </div>
        </div>
    </router-link>
</template>

<script>
export default {
    props: ['comment'],
}
</script>
